module.exports = __webpack_public_path__ + "10f61247cb064bf428ff1836773b1f27.MP3";